let products_on_page = document.getElementById("product-grid");
let next_url = products_on_page.dataset.nextUrl;

async function getNextPage(next_url) {
  try {
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log({ error });
  }
}

async function loadMoreProducts(shouldRetargetUrl = false) {
  if (shouldRetargetUrl) {
    products_on_page = document.getElementById("product-grid");
    next_url = products_on_page.dataset.nextUrl;
    return;
  }

  updateLoadMoreButton({ isLoading: true });

  let nextPage = await getNextPage(next_url);
  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, "text/html");
  const productgrid = nextPageDoc.getElementById("product-grid");
  const new_products = productgrid.querySelectorAll(".grid__item--product");
  const new_url = productgrid.dataset.nextUrl;

  updateLoadMoreButton({ isLoading: false, new_url });

  next_url = new_url;

  if (!next_url) {
    products_on_page.setAttribute("products-load-complete", "");
  }

  for (product of new_products) {
    products_on_page.appendChild(product);
  }
  const shouldUseMarketingTilesSideEffects =
    document.getElementById("marketing-tiles");
  if (shouldUseMarketingTilesSideEffects) {
    loadMoreButtonInjectTiles();
    totalTilesPerPage(!next_url);
  }
  products_on_page.addEventListener("click", saveGridProducts);
}

function updateLoadMoreButton({ isLoading, new_url }) {
  const load_more_btn = document.getElementsByClassName("load-more__btn")[0];
  const load_more_spinner =
    document.getElementsByClassName("load-more__spinner")[0];

  if (isLoading) {
    load_more_btn.setAttribute("loading", "");
    load_more_btn.classList.toggle("hidden");
    load_more_spinner.classList.toggle("block");
  } else {
    load_more_btn.removeAttribute("loading");
    load_more_spinner.classList.toggle("block");
    if (new_url) {
      load_more_btn.classList.toggle("hidden");
    }
  }
}

function saveGridProducts(event) {
  products_on_page.dataset.nextUrl = next_url;
  let previousGrid = products_on_page.outerHTML;
  localStorage.setItem("cached_products_plp", previousGrid);
  localStorage.setItem("cached_selected_plp", event.target.id);
}

function restoreGridProducts() {
  const previousGrid = localStorage.getItem("cached_products_plp");

  if (!previousGrid) return;

  const parser = new DOMParser();
  const grid = parser.parseFromString(previousGrid, "text/html");
  const productgrid = grid.getElementById("product-grid");
  const saved_products = productgrid.querySelectorAll(".grid__item--product");

  next_url = productgrid.dataset.nextUrl;

  updateLoadMoreButton({ isLoading: true, new_url: next_url });

  products_on_page.replaceChildren(...saved_products);

  updateLoadMoreButton({ isLoading: false, new_url: next_url });

  products_on_page.addEventListener("click", saveGridProducts);
  localStorage.removeItem("cached_products_plp");

  const previousProductId = localStorage.getItem("cached_selected_plp");
  const productCard = products_on_page.querySelector(`#${previousProductId}`);
  productCard.focus();
}
